import React from 'react';
import {PlanGetSchema} from '../../../../api/DBSchema/Plan';
import BaseThreatPrevention from '../../AbstractObjects/GatewayPlan/InnerPages/BaseThreatPrevention';

const pageSchema = PlanGetSchema.pages.threatPrevention;
const pageId = pageSchema.pageId;

function PlanThreatPrevention({
    planObject,
    setPlanData,
    setEditorPageId
}) {
    let pageData = planObject[pageId];

    return (
        <BaseThreatPrevention
            pageData={pageData}
            setObjectData={setPlanData}
            setEditorPageId={setEditorPageId}
        />
    );
}

export default PlanThreatPrevention;